<template>
<loader v-bind="{ loading }">
  <form>
    <columns>
      <column>
        <div class="columns">
          <div class="column">
            <text-input
              required
              :error="$root.errorBag.domain"
              :working="savingName"
              @input="updateName"
              :value="app.name"
              :right-icon="nameIcon"
              :icon-class="nameIconClass">
              App Name
            </text-input>
          </div>
          <div class="column">
            <text-input
              classes="has-addons"
              required
              :error="$root.errorBag.domain"
              :working="savingDomain"
              @input="updateDomain"
              :value="app.domain"
              :right-icon="domainIcon"
              :icon-class="domainIconClass">
              <template #left>
                <button class="is-static button">https://</button>
              </template>
              Domain
            </text-input>
          </div>
        </div>
        <columns>
          <column class="is-6">
            <select-input
              :items="teams"
              :value="app.team_id"
              @input="updateTeam"
              value-key="id"
              label-key="name">
              Team
            </select-input>
          </column>
        </columns>
      </column>
      <column class="is-2">
        <div class="is-flex flex-column align-end">
          <div class="is-flex flex-column justify-end">
            <div @click="selectPicture">
              <avatar
                class="cursor-pointer ml"
                :size="100"
                :name="app.name"
                :path="app.logo_url">
              </avatar>
            </div>
            <action-button
              class="mt is-small is-rounded"
              left-icon="pencil-alt"
              @click="selectPicture">
              Change Picture
            </action-button>
          </div>
        </div>
      </column>
    </columns>


    <div class="columns">
      <div class="column">
        <h3 class="is-size-5 has-text-weight-light">Delete App</h3>
        <p class="mb-1">
          By deleting this app all related data will be deleted including scan data, reports and findings.
        </p>
        <action-button @click="deleteApp" left-icon="trash" class="is-danger is-small is-rounded">Delete app</action-button>
      </div>
    </div>
  </form>
</loader>
</template>
<script>
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import filePicker from 'file-dialog'
import { cropImage } from '@/modals'
import Vapor from '@/components/s3-upload'
import { get } from '@/api/request'

export default {

  data: () => ({
    savingDomain: false,
    savingName: false,
    domainIcon: '',
    domainIconClass: '',
    nameIcon: '',
    nameIconClass: '',
    teams: [],
    loading: true,
    canUpdateTeam: false,
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Settings')
    get('api/team-list', ({data}) => {
      this.teams = data
      this.loading = false
      setTimeout(() => this.canUpdateTeam = true, 300)
    })
  },

  methods: {
    async selectPicture() {
      let files = await filePicker({
        accept: 'image/*',
        multiple: false
      })
      if (files && files.length) {
        let image = new Image
        image.onload = () => {
          if (image.width > 250 || image.height > 250) {
            this.cropAndUpload(files[0])
          } else {
            this.$alert(
              'Picture too small',
              'Please select a picture that is at least 250px × 250px.'
            )
          }
        }
        image.onerror = () => {
          this.$toast.error('That file could not be selected.')
        }
        image.src = URL.createObjectURL(files[0])
      }
    },

    async cropAndUpload(image) {
      if (await cropImage('Crop the app logo', image, this.uploadImage)) {
        this.$toast.success('Logo updated successfully.')
      }
    },

    async uploadImage(file) {
      this.$store.dispatch('app/uploadLogo', {file})
    },
    updateDomain: debounce(function(value) {
      this.$store.commit('app/updateDomain', value)
      if(value.length < 1) {
        this.savingDomain = false
        return
      }
      this.savingDomain = true
      this.$store.dispatch('app/updateDomain', value).then(() => {
        this.savingDomain = false
        this.domainIcon = 'check-circle'
        this.domainIconClass = 'has-text-success'
        setTimeout(() => {
          this.domainIcon = ''
          this.domainIconClass = ''
        }, 2500)
      }).catch(error => {
         this.savingDomain = false
      })
    }, 800),
    updateName: debounce(function(value) {
      this.$store.commit('app/updateName', value)
      if(value.length < 1) {
        this.savingName = false
        return
      }
      this.savingName = true
      this.$store.dispatch('app/updateName', value).then(() => {
        this.savingName = false
        this.nameIcon = 'check-circle'
        this.nameIconClass = 'has-text-success'
        setTimeout(() => {
          this.nameIcon = ''
          this.nameIconClass = ''
        }, 2500)
      }).catch(error => {
         this.savingName = false
      })
    }, 800),
    updateTeam(value) {
      if(!this.canUpdateTeam) return
      this.$store.dispatch('app/updateTeam', value).then(() => {
        this.$toast.success('Team updated')
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteApp() {
      if(await this.$confirm({
        title: 'Delete App',
        confirmText: 'DELETE',
        confirmClass: 'is-danger',
        message: 'Are you certain that you would like to DELETE is app?'
      })) {
        this.$store.dispatch('app/deleteApp', this.app.id).then(() => {
          this.$toast.success('App deleted')
          this.$router.push({
            name: 'apps'
          })
        })
      }
    }
  },

  computed: {
    ...mapGetters('app', [
      'app'
    ])
  }
}
</script>
